export default __webpack_public_path__ + "static/media/Paint It Black.ca6ac6d6.png";